export default "__VITE_ASSET__BfhKXmMs__"